import {Organization} from "../../../types/Organization";

type FilterOrganizationsProps = {
  organizations: Organization[];
  searchTerm: string;
  selectedGroup: string;
};

export const filterOrganizations = ({
  organizations,
  searchTerm,
  selectedGroup,
}: FilterOrganizationsProps) => {
  return organizations.filter((org) =>
    org.name.includes(searchTerm.trim())
    && (selectedGroup ? org.group.includes(selectedGroup) : true)
  );
};
